import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { GoogleMap, MapInfoWindow, MapMarker } from "@angular/google-maps";
import { Observable } from "rxjs";

import { DirectoryItemModel } from "../../models/directory-item.model";
import { BaseSearchResultsModel } from "../../../models/base-search-results.model";
import { MapMarkerModel } from "./map-marker.model";
import { GoogleMapService } from "./google-map.service";
import LatLngBounds = google.maps.LatLngBounds;
import LatLng = google.maps.LatLng;
import LatLngLiteral = google.maps.LatLngLiteral;

@Component({
    selector: "pcg-ng-google-map",
    templateUrl: "./google-map.component.html"
})
export class GoogleMapComponent implements OnInit {
    @Input() public searchResult$: Observable<BaseSearchResultsModel<DirectoryItemModel>>;
    @Input() public viewPageUrl: string;

    private static DEFAULT_LOCATION = {
        lat: 51.0626,
        lng: -1.3167
    };

    private static BRITAIN_BOUNDS = new LatLngBounds({east: 1.76, west: -6.22, north: 58.63, south: 49.96});

    @ViewChild("mapElement", { static: false })
    public mapComponentRef: GoogleMap;

    public location: google.maps.LatLngLiteral = GoogleMapComponent.DEFAULT_LOCATION;

    public options: google.maps.MapOptions = {
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        disableDoubleClickZoom: true,
        scrollwheel: false,
        zoomControl: true,
        minZoom: 5,
        maxZoom: 20
    };

    public zoom = 13;
    public markers: Array<MapMarkerModel> = [];

    @ViewChild(MapInfoWindow, { static: false })
    public infoWindowRef: MapInfoWindow;
    public infoWindowContent: string;

    private _isMapInitialized: boolean = false;

    public constructor(private googleMapService: GoogleMapService) {
    }

    public ngOnInit(): void {
        this.initializeMap();
        this.googleMapService.markers$.subscribe((markers) => {
            this.markers = markers;

            const bounds = new google.maps.LatLngBounds(GoogleMapComponent.DEFAULT_LOCATION);
            for (const marker of markers) {
                if (this.isBritainCoordinates(marker.position))
                    bounds.extend(marker.position);
            }

            setTimeout(() => {
                if (this.markers.length > 0){
                    this.mapComponentRef.fitBounds(bounds, 0);
                }
            }, 100);
        });
    }

    public initializeMap(): void {
        if (this._isMapInitialized) {
            return;
        }

        navigator.geolocation.getCurrentPosition(position => {
            this.location = {
                lat: position.coords.latitude,
                lng: position.coords.longitude
            };
        }, error => {
            console.warn(error.message);
        });

        this._isMapInitialized = true;
    }

    public onMapMarkerClicked(marker: MapMarker, content: string): void {
        this.infoWindowContent = content;
        this.infoWindowRef.open(marker);
    }

    private isBritainCoordinates(position: LatLng | LatLngLiteral): boolean {
        return GoogleMapComponent.BRITAIN_BOUNDS.contains(position);
    }
}
